import React from 'react';
import PaymentCardView from './views/PaymentCardView';
import { usePaymentCard } from './hooks/PaymentCard.hook';
import { useSelector } from 'react-redux';
import * as Yup from 'yup';

const PaymentCardController = () => {
  const { loading, error, handleSubmit } = usePaymentCard();
  const languageData = useSelector(state => state.lenguage?.lang);

  const initialValues = {
    email: '',
    password: '',
  };

  const validationSchema = Yup.object().shape({
    email: Yup.string()
      .email(languageData === 'EN' ? 'Invalid email' : 'Email inválido')
      .required(languageData === 'EN' ? 'Required' : 'Requerido'),
    password: Yup.string()
      .min(
        6,
        languageData === 'EN' ? 'Minimum 6 characters' : 'Mínimo 6 caracteres',
      )
      .required(languageData === 'EN' ? 'Required' : 'Requerido'),
  });

  const onPaymentCard = async values => {
    console.log(' DATOS GUARDADOS EN CONTINUE:', values);
    console.log(' Email:', values.email);
    console.log(' Password:', values.password);
  };

  const handleRegister = () => {
    console.log('Redirigiendo a registro...');
  };

  const handleBack = () => {
    window.history.back();
  };

  return (
    <PaymentCardView
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={values => handleSubmit(values, onPaymentCard)}
      loading={loading}
      error={error}
      languageData={languageData}
      onBack={handleBack}
      onRegister={handleRegister}
    />
  );
};

export default PaymentCardController;
